export default {
sets: `Mappák`,
stats: `Statisztikák`,
discover: `Felfedezés`,
guides: `Útmutatók`,
settings: `Beállítások`,
unsupportedBrowserBody: `Flashcards does not support this browser. Download the latest version of Chrome or Opera, or download our iPhone, or Android Application`,
unsupportedBrowserTitle: `Nem támogatott böngésző`,
noData: `Nincs mutatható adat`,
contactUsTitle: `Szeretjük tudni, hogy hogyan használod es szereted alkalmazásunkat, és hogy hogyan javíthatjuk az alkalmazást. Írj nekünk egy üzenetet bármilyen kérdezéssel, vagy hibajelentésekkel`,
rateAppStore: `Értékelés az AppStore-ban`,
rateGoogle: `Értékelés a Google Play-en`,
close: `Bezárás`,
shareFriends: `Oszd meg a barátaiddal`,
noCardsQ: `Nincsenek még kártyáid?`,
noCardsS: `Válassz a gyűjteményünkből kezdésként`,
suggestSet: `Javaslás`,
createOwn: `Készítsd el a sajátodat`,
search: `Keresés`,
loading: `Betöltés`,
words: `Szavak`,
downloads: `Letöltések`,
export: `Exportálása`,
import: `Importálás`,
importing: `Importálás ... Ne zárja be az alkalmazást`,
importPreview: `Importálás előnézet`,
howQuizlet: `Hogyan importálhat a Quizletből`,
cards: `Kártyák`,
importPreviewStatus: `__ kifejezés készen áll a meglévő ___ kártya mellé adáshoz`,
importPaste: `Illesszd be a kártyákat a fenti mezõbe`,
setTotalLimitReached: `Egy mappábba csak 3000 kártya lehet összesen`,
studying: `Tanulandó`,
learnt: `Megtanult`,
mastered: `Elsajátított`,
new: `Új`,
noTerm: `Nincs kifejezés`,
noDef: `Nincs definíció`,
cardSaved: `Kártya mentett`,
reviews: `Áttekintések`,
practices: `Gyakorlatok`,
flashcards: `Kárták`,
alerts: `Értesítések`,
corrects: `Helyesek`,
mistakes: `Hibák`,
reviewCycle: `Áttekintési ciklus`,
reviewsLeft: `Hátramaradt áttekintések`,
lastReview: `Utolsó áttekintések`,
nextReview: `Következő áttekintések`,
hideHistory: `A teljes történelem elrejtése`,
showHistory: `Teljes történelem megjelenítése`,
strength: `Erő`,
star: `Csillag`,
image: `Kép`,
tag: `Címke`,
added: `hozzáadva`,
removed: `eltávolítva`,
reviewedFrom: `Áttekintve __-el`,
notifications: `Értesítések`,
reviewedPractice: `Áttekintve __, a ___ gyakorlat`,
successfully: `sikeresen`,
unsuccessfully: `sikertelenül`,
termUpdated: `Kifejezés módosítva`,
defUpdated: `Definíció módosítva`,
flashcardCreated: `Kártya létrehozva`,
dropboxImage: `A képek hozzáadásához be kell kapcsolnod a Dropboxot szinkronizációt`,
deleteImgConfirm: `Biztos, hogy törölni szeretné ezt a képet?`,
uploading: `Feltöltés`,
save: `Mentés`,
uploadImageFail: `Nem sikerült feltölteni a képet`,
imageUploaded: `A kép feltöltve`,
setNotFound: `A mappa nem található`,
notEnoughCards: `Nincs elég kártya!`,
of: `__, a ___-ból`,
on: `Bekapcsolva`,
off: `Kikapcsolva`,
auto: `Automatikus`,
manual: `Manuális`,
pronounce: `Kiejt`,
practiceCompleted: `Gyakorlatot befejezve`,
closePractice: `Gyakorlat bezárása`,
autoplay: `Automatikus lapozás`,
secFlipSecNext: `__ mp fordítás, ___ mp lapozás`,
autopronounce: `Automatikus kiejtés`,
onlyTerm: `Csak kifejezés`,
onlyDef: `Csak definíció`,
termAndDef: `Kifejezés és definíció`,
savePractice: `Akarod menteni a gyakorlatot?`,
continueLater: `Igen, folytatom később`,
deletePractice: `Nem, gyakorlat törlése`,
term: `Kifejezés`,
def: `Definíció`,
monA: `H`,
tueA: `K`,
wedA: `Sz`,
thuA: `Cs`,
friA: `P`,
satA: `S`,
sunA: `V`,
reviewGoal: `Áttekintési cél`,
dailyGoal: `Napi cél`,
edit: `Szerkesztés`,
setUp: `Beállít`,
noRecentPractice: `Nincsenek elmentett gyakorlatok`,
continueLastReview: `Utolsó áttekintés folytatása`,
dueCards: `Esedékes kártyák`,
studyNow: `Tanulás`,
newCards: `Új kártyák`,
terms: `Kifejezések`,
defs: `Definíciók`,
validCardsOf: `Csak __ a ___ kiválasztott kártyát lehet gyakorolni, mivel a többieknek nincsen vagy a kifejezésük, vagy a definíciójuk`,
reviewCards: `Kártyák áttekintése`,
customizePractice: `Gyakorlat testreszabása`,
next: `Következő`,
iWasRight: `Igazam volt`,
printProAlert: `Vásárold meg a Pro csomagot, a több mint 20 kártya nyomtatásához`,
print: `Nyomtatás`,
printWidth: `Kifejezés-definíció szélesség`,
printFont: `Betűméret`,
printBorder: `Szegély`,
printMargin: `Oldalszegény`,
printPadding: `Szó Párnázás`,
preparingFile: `Fájl előkészítése`,
notificationsBlocked: `Az értesítések nem lettek engedélyezve, ez megtehetõ a telefon beállításaiban`,
ranOutOfWords: `Elfogytak a kártyák, indítsd újra a gyakorlatot az újrakezdéshez`,
ranOutOfWordsShort: `Elfogyott a szavak`,
ranOutOfWordsBody: `Nyisd meg az alkalmazást az új szavak ütemezéséhez`,
proIncreaseNotifications: `A értesítések számát 10-ről 50-ig növelheted a prémium verzióval`,
schedule: `Menetrend`,
frequency: `Frekvencia`,
mode: `Mód`,
tM1: `1 perc`,
tM2: `2 perc`,
tM5: `5 perc`,
tM10: `10 perc`,
tM15: `15 perc`,
tM30: `30 perc`,
tH1: `1 óra`,
tH2: `2 óra`,
termPassive: `Passzív kifejezés`,
termActive: `Aktív kifejezés`,
defPassive: `Passzív definíció`,
defActive: `Aktív definíció`,
scheduledIn: `Ütemezve __ perc mulva`,
scheduledAlertsProT: `Növelje az ütemezhető figyelmeztetéseket a prémium verzióval`,
scheduledAlertsProB: `A prémium verzióval 10-ról, 50-ra növelheted az értesítések számát`,
seeFeatures: `Funkciók felfedezése`,
defAndTerm: `Meghatározás és definíció`,
termHoldDef: `Kifejezés, nyomás a definíció-ért`,
defHoldTerm: `Definíció, nyomás a kifejezés-ért`,
notificationType: `Értesítési típusa`,
copyToClipboard: `Vágólapra másolja`,
enterAuthCode: `Kérjük, adja meg az engedélyezési kódját`,
invalidCode: `Érvénytelen kód`,
copied: `Másolva`,
promoH2: `Flashcard Manager Pro`,
promoP: `Tanulj hatékonyabban a saját tempódban a prémium funkciókkal`,
promoBtn: `Fedezzd fel az összes funkciót`,
setDropboxH2: `Dropbox Sync`,
setDropboxPOff: `Engedélyezd a Dropbox szinkronizálásást a mappák, kártyák, címkéket naprakészen tartásához az összes eszközödön`,
setDropboxPOn: `Az adataid szinkronizálva vannak`,
setDropboxBtn: `Szinkronizál`,
status: `Állapot`,
syncNow: `Szinkronizálja most`,
contact: `Kapcsolat`,
contactUs: `Lépjen kapcsolatba velünk`,
useFromBrowser: `Használás a böngészőbõl`,
useFromBrowserMsg: `Látogass el a flashcardsmadesimple.com-ra a számítógépeden, és állítsd vissza a kártyákat és a licencet a Dropbox Sync használatával`,
termsPrivacy: `Feltételek és adatvédelmi irányelvek`,
dailyReviewGoal: `Napi áttekintési cél`,
numberTerms: `Kifejezések száma`,
selectTerm: `Válassz definiciót, kifejezés sugóval`,
selectDef: `Válassz kifejezést, definició sugóval`,
pronounceTerm: `Válassz definiciót, kifejezés kiejtéssel`,
pronounceDef: `Válassz kifejezést, definició kiejtéssel`,
typeTerm: `Írj definiciót, kifejezés kiejtéssel`,
typeDef: `Írj kifejezést, definició kiejtéssel`,
quizTypes: `Preferált kvíztípusok`,
spacedRepetition: `Spaced Repetition ütemterv`,
spacedRepetitionP: `A spaced repetition lehetővé teszi, hogy a szavakat kevesebb erőfeszítéssel sajátíthasd el. Az alapértelmezett ütemezés 1-3-7-15-31 nap, de egyedi is beállíthatja.`,
spacedRepetionScheduleItem: `__ nappal a ___ áttekintés után (nap ____)`,
atLeastOneSchedule: `Legalább egy ütemezésre van szükség`,
revisionLimitReached: `Elérted a maximális revsision számot`,
addReviewSchedule: `Új áttekintési ütemterv hozzáadása`,
autoMarkLearnt: `Automatikus jelzés megtanultként`,
autoMarkMastered: `Automatikus jelzés elsajátitoottként`,
tagManager: `Címkék kezelése`,
delete: `Törlés`,
addTag: `Új címke hozzáadása`,
tagDeletionH: `Címke törlése`,
tagDeletionP: `Biztosan törölni szeretnéd ezt a címkét?`,
cancel: `Megszakítás`,
daysAfterLastReview: `Napok az utolsó áttekintés után`,
linkDropbox: `Dropbox-hoz csatlakozás`,
startSync: `Szinkronizálás elkezdése`,
starred: `Csillagozott`,
images: `Képek`,
tags: `Címkék`,
types: `Típusok`,
activeDays: `Aktív napok`,
inactiveDays: `Inaktív napok`,
longestStreak: `Leghosszabb streak`,
dailyGoalsCompleted: `Napi befejezett célok`,
dailyGoalsFailed: `Napi sikertelen célok`,
typePairs: `Típuspárok`,
reviewTypes: `Áttekintési típusok`,
typePractice: `Írási gyakorlat`,
pronouncePractice: `Kiejtés gyakorlatot`,
selectPractice: `Kiválasztási gyakorlatot`,
notificationReview: `Áttekintés értesítéssel`,
flashcardReview: `Kártya Áttekintések`,
studyset: `Mappa`,
enterStudysetName: `Adjd meg egy mappa nevet`,
studysetName: `Mappa név`,
termType: `Kifejezés típus / nyelv`,
defType: `Definíció típus / nyelv`,
exportCards: `Kártyák exportálása`,
importCards: `Kártyák importálása`,
quiz: `Kvíz`,
showingOutOfCards: `__ / ___ kártya mutatva`,
showingAllCards: `Minden kártya mutatva van`,
recording: `Felvételek`,
downloadSet: `Agregar a mis sets`,
addNewCard: `Új kártya`,
saveStudyset: `Mappa mentése`,
studysetDeletionH: `Mappa törlése`,
studysetDeletionP: `Biztos, hogy törölni szeretnéd ezt a mappát, ez szintén törli fogja az összes tartalmazott kártyát is.`,
cardDeletionH: `Kártya törlése`,
cardDeletionP: `Biztosan törölni szeretnéd ezt a kártyát`,
cardLimitReached: `Csak 3000 kártya lehet egy mappában`,
limitExceeded: `Limit meghaladva`,
atLeastTenCards: `Adj hozzá legalább 10 kártyát a gyakorlatokokhoz`,
searchInAll: `Keresés az összes mappában`,
noMatch: `Nincsenek eredmények`,
atLeastThreeChars: `Adj meg legalább 3 karaktert a kereséshez`,
noSets: `Nincsenek még mappák`,
startingSync: `Szinkronizálás elindult`,
noSetsP: `Válassz az alábbi opciók közül`,
startingSyncP: `Az adatokat beszerzése a Dropbox-ról, ez egy ideig eltarthat`,
createNewStudyset: `Új mappa létrehozása`,
restoreFromBackup: `Visszaállítás a biztonsági mentési fájlból`,
setStarterPacks: `Kártya starterpack-ek`,
selectPracticeType: `Válasszd ki a gyakorlat típusát`,
noDueCards: `Még nincsenek esedékes kárták`,
noNewCards: `Nincsenek új kártyák`,
subscriptionH: `Vásárold meg a prémium verziót, hogy élvezzhesd az összes funkciót, és hogy támogasd a fejlesztést`,
buyLifetimePro: `Vásároljon Lifetime Pro-t __ dollárért`,
restorePurchase: `Vásárlás visszállítása`,
termsPrivacyC: `Feltételek és adatvédelmi irányelvek`,
licenceShare: `Ha egy másik eszközről licencet vásároltál, akkor megoszthatod ezzel a készülékkel, ha mindkét eszközön engedélyezed a Dropbox szinkronizálást`,
enterTagName: `Adj meg a címke nevet`,
invalidName: `Érvénytelen név`,
create: `Létrehozás`,
name: `Név`,
tagName: `A címke neve`,
color: `Szín`,
back: `Vissza`,
rowSeparator: `Sor szeparáló`,
termDefSeparator: `Kifejezés - Definíció szeparáó`,
output: `Másold a szavakat innen`,
inputCards: `Illeszd be ide a szavakat`,
review: `Áttekintés`,
language: `Nyelv`,
archiveReversible: `Archiválás (Visszaállítható)`,
deletePermanent: `Törlés (Végleges)`,
archivedCards: `Archivált Kárták`,
masteredCards: `Elsajátitott Kárták`,
due: `Esedékes`,
reviewed: `Áttekintve`,
markReviewed: `Megjelölés Áttekintetté`,
markMastered: `Megjelölés Elsajátítottá`,
forXYCards: `__ ___ kártyára`,
createdAtSortBy: `Létrehozási dátum`,
lastReviewedSortBy: `Utolsó Áttekintési dátum`,
reviewCountSortBy: `Áttekintési alkalmak`,
strengthSortBy: `Erő`,
termSortBy: `ABC sorrend (Kifejezés)`,
definitionSortBy: `ABC sorrend (Definíció)`,
ascSortBy: `Növekvő`,
descSortBy: `Csökkenő`,
featureSync: `Tanulj bármit, bárhol és bármikor, az összes kártyáddal az összes eszközödön`,
featureSpacedrepetition: `Tartsd a szemed a fejlődéseden, és mindig gyakorold, amit kell gyakorolnod`,
featureNotifications: `Tanulj az alkalmazás megnyitása nélkül, rugalmas értesítésekkel`,
featureFlashcards: `Automatikus lapozás, amikor a kezeid, vagy a szemeid elfoglaltak`,
featureQuiz: `Párosíts, írj, hallgass`,
featureStats: `Tegyél jobb betekintést az eredményeidbe, és keresss az összes kártyád között`,
featureImport: `Mi sohasem látjuk az adataidat, és könnyen exportálhatod és importálhatod az összes adatot`,
featurePrint: `Tanulj a telefonod nélkül, a kártyáid nyomtatásával, és DIY-oljd a saját tanuló készülékedet`,
splashIntro: `Tanuld az összes kártyádat, akárhol, a te tempódban`,
selectSortOrder: `Sorrend`,
selectSortProp: `Rendezési mező`,
applyFilters: `Szűrők alkalmazása`,
selectSetType: `Mit akarsz gyakorolni?`,
getStarted: `Nekikezdés`,
tapToUnarchive: `Érintsd meg a kártyákat a visszaállításhoz`,
untitled: `Névtelen`,
sortHintNew: `A leghosszabb idővel ezelőtt létrehozott kártyákat fogod látni elöszzör`,
sortHintDue: `A leghosszab ideje esedékes kártyákat fogod látni elösször`,
sortHintOther: `A leghosszabb ideig nem áttekintett kártákat fogod látni elösször`,
flashcardsWhen: `, legjobb amikor dolgozol, mert csak egy tekintést igényel, és semmi tapintást`,
notificationsWhen: `, legjobb amikor kint vagy, mert csak rátekinthetsz az értesítési központra`,
quizWhen: `, legjobb amikor a teljes figyelmedet ráfordíthatod a tanulásra`,
features: `Jellemzők`,
ratings: `Minősítések`,
notificationDailyCatchUpBody: `Új: __, esedékes: ___, tanulás alatt: ____, megtanult: _____, elsajátított: ______`,
notificationDailyCatchUpTitle: `Napi statisztika`,
reviewedJN: `Áttekintve most`,
customUpdated: `Egyéni szöveg frissítve`,
customTextField: `Szinonimák, példák, stb.`,
field: `Mezö`,
link: `Link`,
backToParentCard: `Vissza a szülői kártyához`,
discard: `Elvetés`,
failedImageLoad: `Nem sikerült betölteni a képet, győződ meg az internet csatlakozáshoz`,
printDIYLabel: `DIY-d a saját tanuoló eszközödet`,
reviewGraphChart: `Áttekintési rács`,
langNotSet: `Nincsen nyelv`,
pronouncationLangInfo: `A kiejtés engedélyezéséhez ki kell választani a kifejezés és a definíció nyelvét. A nyelvek mellett hangszóró jel jelenik meg, ha a készülék támogatja ezt a nyelvet`,
clearFilters: `Szűrő törlése`,
subFreeUnlimited: `Korlátlan vizsgák, kártyák, gyakorlatok, keresés és szinkronizálás`,
customFields: `Egyedi mezők`,
subLinks: `Kártya linkek`,
subPrint: `Nyomtatás / mappa`,
subNotifications: `Értesítés az alkalmazás megnyitása előtt`,
subCardsStudysets: `Kártyák / mappa`,
subRevisionCycles: `Egyéni felülvizsgálati ciklusok`,
subscriptionHEnd: `A Prémium csomaggal mutathatod, hogy értékeled a kemény munkánkat, és bátorítást és kávét ad az új dolgok létrehozására.`,
subFree: `Ingyenes`,
subPro: `Prémium`,
guideSpacedRepetition: `Hogyan müködik a Spaced Repetition & gyakorlati típusok`,
guideSearch: `Keresés és szűrés`,
guideSync: `Engedélyezd a biztonsági mentést és szinkronizálást`,
guidePronunciation: `A kiejtések engedélyezése`,
guideImport: `Kártyák importálása más forrásból`,
guideAccess: `Ki fér hozzá az adataimhoz?`,
guideData: `Milyen adatokat gyűjtünk?`,
guideContact: `Segítségre van szüksége bármi másnál? Írj nekünk`,
arrowStrength: `Állítsd be, hogy mennyire jól ismered ezt a kártyát`,
arrowImage: `Képek hozzáadása`,
arrowField: `További egyéni szövegmezők hozzáadása`,
arrowTag: `Csatolj címkéket`,
arrowStar: `Kedvencnek jelölés`,
arrowLink: `Más kártyákhoz linkelés`,
arrowGoal: `Állíts be napi áttekintési célt`,
arrowDue: `Tanulj kártyákat, amelyeket felül kell tekintened`,
arrowNew: `Tanulj kártyákat, amelyeket még nem tekintettél meg`,
arrowMastered: `Ha nincsenek esedékes vagy új kártyáid, akkor áttekintheted az elsajátított kártyákat mégegyszer`,
arrowImport: `Kárták importálása más alkalmazásból`,
arrowNewCard: `Új kártya hozzáadása`,
dropboxStep1: `1. Hozzáférési kód kérése a Dropbox-tól`,
dropboxStep1Btn: `Bejelentkezés Dropbox-al`,
dropboxStep2: `2. Add meg a kapott hozzáférési kódot`,
dropboxStep2Input: `Írd ide a kódot`,
dropboxStep3: `3. Szinkronizálást elindítsa`,
alreadyLinked: `Már linkelt, érintsd meg a link eltávolításához`,
selectCardsToLink: `Válassz ki a kártyákat a linkeléshez`,
unsupportedLangP: `Válasz egy nyelvet aminek a kiejtését támogatja az eszközöd`,
links: `Linkek`,
emailUs: `Email küldés`,
whatsappUs: `WhatsApp`,
printMinHeight: `Min. sor magasság`,
exportType: `Exportálási fájl típus`,
generateFileText: `Fájl generálása`,
generatatingFile: `Fájl generálása folyamatban`,
verySmall: `Nagyon kicsi`,
small: `Kicsi`,
normal: `Normál`,
big: `Nagy`,
veryBig: `Nagyon nagy`,
repeatNTimes: `__ Ismétlés`,
pause: `Szünet`,
for: `eddig`,
say: `Mond`,
defShort: `Defin.`,
times: `-szer`,
autoplayPreferences: `Lejátszási beállítások`,
autoPlay1: `Szünet az előző szó után`,
autoPlay2: `A kifejezések kiejtésének a száma`,
autoPlay3: `Definíció előtti szünet`,
autoPlay4: `Definíciók kiejtésének a száma`,
autoPlay5: `Szünet a következő szó előtt`,
autoPlay6: `Ugyanaz a kárty ismétlése`,
startAutoPlay: `Lejátszás Indítása`,
autoPlayOffConfirm: `Kapcsold ki az automatikus lejátszást a kézi vezérlés engedélyezéséhez`,
turnOff: `Kikapcsolás`,
keepPn: `Bekapcsolva hagyás`,
foundIn: `__-ben találva`,
repeat: `ismétlés`,
stop: `Stop`,
listenInBreak: `Zenék / podcastok a szünetekben`,
contextSearch: `Kontextuskeresés`,
contextSearchText: `Szerezzen példákat arra, hogy hogyan használják __-t különböző mondatokban`,
transalteSearch: `Fordítás`,
translateSearchText: `__ Fordítása ___-ra`,
synonymSearch: `Szinonima keresés`,
synonymSearchText: `Keress szinonimákat __-ra`,
selectToAdd: `Válasszd ki a kártyához hozzáadni kívánt eredményeket`,
addToCard: `Hozzáadás`,
hideFromPractice: `Eltüntetés ebbõn a körböl`,
setLanguageRequired: `Válasszd ki a mappa nyelvét a beállításokban`,
fieldNeedsText: `Írj be valamit ebbe a mezőbe a keresés előtt`,
possibleDupe: `Lehetséges másolat`,
loadNextXCards: `A következő __ kártya betöltése`,
repeatPractice: `E __ kártya megismétlése`,
keepScreenOnInfo: `Előfordulhat, hogy be kell állítania az automatikus zárolási beállítást, hogy a képernyő beilleszkedjen az automatikus lefolyás közben.`,
siteLoginH2: `SFM-fiók`,
siteLoginP: `Ez a fiók megengedi a kártyáid megosztását a barátaiddal, a tanulóiddal vagy az egész közösséggel`,
logOut: `Kijelentkezés`,
logIn: `Belépés`,
createAccount: `Új fiók létrehozása`,
signUp: `Regisztráció`,
username: `Felhasználónév`,
email: `Email`,
password: `Jelszó`,
networkError: `Hálózati hiba`,
fillAllDetails: `Töltsd ki az összes részletet`,
noUserWithDetails: `A megadott felhasználó nem találhatók`,
userAlreadyExists: `Az adott e-mail vagy felhasználónév már létezik`,
signUpOrLoginToCont: `Regisztrálj, vagy jelentkezz be a folytatáshoz`,
atLeastOneCardToShare: `Legalább egy kártyát meg kell osztania`,
publishingStudyset: `Mappa megosztása`,
updatesDetected: `Frissítések elérhetōek, folytatás? (Törölve: __, frissítve: ___, új: ____)`,
updatesApplied: `Frissítve`,
alreadyUpToDate: `Már naprakész`,
practiceTypeArrow: `Fedezze fel különböző gyakorlási módokat`,
share: `Megosztás`,
sharingModalIntro: `Osszd meg kártyákat ebben a mappában a barátaiddal, a tanulóiddal vagy az egész közösséggel`,
whatIsShared: `Mi lesz megosztva`,
whatIsNotShared: `Mi NEM lesz megosztva`,
whatIsSharedText: `A név, a beállított kifejezés nyelv, a definiton nyelv, az összes mellékelt kártyák, fogalommeghatározások, egyedi szövegmezők és képek`,
whatIsNotSharedText: `Bármely kártyaerősség, csillagok, linkek, címkék és a felülvizsgálati története`,
checkForSharedUpdates: `Frissítések Ellenőrzése`,
fetchUpdates: `Frissítések Ellenőrzése`,
youSharedStudyset: `Ez a mappa meg van osztva`,
publishChanges: `A változások mentése és közzététele`,
redeem: `Beváltás`,
noAds: `Nincsenek hirdetések`,
dupeDetection: `Duplikált kártya kimutatás`,
coffeeFeature: `Kávé, ami segít nekünk több funkciót fejleszteni`,
shareLink: `Hivatkozás megosztása`,
coffeeForUs: `You will get a lifetime licence for only __, which gives Emily 6 coffees, Dominik 3 coffees, and Russ 3 coffees, which will fuel us for about 39 hours to make this app event better`,
sharingCards: `Kártyák megosztása`,
published: `Közzétéve`,
alreadyHaveAccount: `Már van fiókod?`,
notAlreadyHaveAccount: `Még nincs fiókod?`,
startPractice: `Gyakorlat Indítása`,
selectQuizTypes: `Kvíztípusok Választása`,
correct: `Helyes`,
incorrect: `Helytelen`,
yes: `Igen`,
no: `Nem`,
levelSilver: `Ezüst szint __`,
levelGold: `Arany szint __`,
levelPlatinum: `Platinum szint __`,
levelDiamond: `Gyémánt szint __`,
levelJade: `Jade szint __`,
reviewsLeftGoal: `__ értékelés a napi célért`,
dailyGoalAchieved: `Napi Cél Elérve`,
share: `Megosztás`,
rateApp: `Értékelés`,
allStats: `Statisztikák`,
reviewTimeError: `Várkozás hiba után`,
reviewTimeCorrect: `Várkozás siker után`,
pronounceTermAfterReview: `Kifejezés Kiejtés`,
pronounceDefinitionAfterReview: `Definíció Kiejtése`,
practice: `Gyakorlat`,
notificationsScheduledInfo: `__ értesítések ütemezve`,
wellDone: `Szép munka`,
keepItUp: `Csak így tovább`,
youRock: `Király vagy`,
niceOne: `Szép`,
lnSelect: `Válasszon nyelvet`,
sampleData: `Nincsenek áttekintés, mintaadatok megjelenítése`,
reviewFreq: `Felülvizsgálati frekvencia`,
selectPractice: `Gyakorlat: Kiválasztás`,
spellPractice: `Gyakorlat: Irás`,
connectPractice: `Gyakorlat: Csatlakoztatás`,
languages: `Nyelvek`,
languagesPairs: `Nyelvpárok`,
shareArrow: `Kártyák megosztása barátokkal, tanulókkal, vagy az egész közösséggel`,
cardsPerRound: `Kártyák / kerek`,
showAll: `Mutasd az összeset`,
supportedLangsVary: `A támogatott nyelvek változhatnak`,
practiceWithoutSave: `A gyakorlat nem mentett`,
practiceWithoutSaveBody: `Nem adta hozzá ezt a pályázást a gyűjteményéhez, szeretné hozzáadni most, hogy megmentse a tanulmány előrehaladását?`,
saveSetNow: `Mentse a kártyákat a gyűjteményhez`,
continueWithoutSaveSave: `Indítsa el a gyakorlatot mentés nélkül`,
createdBy: `Készítette`,
setSavedToYourCollection: `Mentve`,
accountBackupDisclaimer: `Felhívjuk figyelmét, hogy ez a fiók csak tanulmánykészletek másokkal való megosztására használható, és NEM használható a tanulmánykészletek vagy kártyák biztonsági mentésére vagy szinkronizálására. Az összes adat szinkronizálásához és biztonsági mentéséhez használja a Dropbox Sync alkalmazást`,
syncEnabled: `Szinkronizálás engedélyezve, letölti a folyamatban lévő tartalmat`,
searchAllSets: `Keresés más felhasználóktól`,
anyLanguage: `Bármely nyelv`,
trendingIn: `Trendi`,
manualBackups: `Manuális biztonsági mentés`,
manualBackupCreate: `Létrehozás`,
confirmManualImport: `Biztosan szeretnéd az összes aktuális adatot lecserélni ezzel a biztonsági másolattal? Ez csak az új eszközökön ajánlott`,
importFromManualBackup: `Importálás a biztonsági mentésből`,
imgOfflineSets: `Képek automatikus letöltése offline tanuláshoz`,
unsupportedDeviceCache: `Ez a szolgáltatás csak az iOS vagy az Android alkalmazásból érhető el`,
shareChanges: `Share __ changes`,
publiclySearchable: `Publikusan kereshető`,
description: `Leírás`,
restoreFromDropboxBackup: `Visszaállítás Dropbox biztonsági mentéséből`,
imageCacheStudysetSub: `[Csak iOS & Android] Kép letöltése offline tanuláshoz`,
keywordsOrLangNeeded: `Egy kulcsszó vagy nyelv használata kötelező`,
dropboxAlreadyLinked: `A Dropbox fiók már linkelve van`,
noSetUpdateAccess: `Nincs hozzáférésed a tanulmánykészlet szerkesztéséhez.`,
confirmSetOwnerLogin: `Ha te vagy a tulajdonos, akkor próbálj meg újra bejelentkezni a fiókodba.`,
uninitedRestriction: `To save your progress, first you have to add this studyset to your collection`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Nem sikerült konszolidálni a tárolót`,
consolidateStorageDone: `Tárolási konszolidáció, kérjük, hagyjon egy órát a Dropbox számára, hogy befejezze a régi fájlok eltávolítását, mielőtt új eszközre jelentkezne be.`,
consolidatingStorage: `A tároló konszolidálása ...`,
deleteAccount: `Fiók törlése`,
consolidateStorageDescription: `Ez a művelet újraindítja a biztonsági mentési fájlokat, így az új eszközök beállítása gyorsabb lesz`,
consolidatingStorageConfirm: `Győződjön meg arról, hogy az összes változtatás már befejezte a szinkronizálást, ne szinkronizáljon más eszközöket, amíg ez a folyamat zajlik. Akarod folytatni?`,
consolidateStorage: `Konszolidálja a tárolót`,


}